import React from 'react';
import DriverPersonalComponent from '../components/driverComponents/DriverPersonalComponent';
import AdminHeader from '../components/AdminHeader';
import { useSelector } from 'react-redux';
import { Alert } from '@mui/material';

function DriverDetailsScreen() {
  const { data, error } = useSelector((state) => state.adminDriverDetail ?? {});
  const driver = data?.driver;

  return (
    <div className="flex w-full h-screen overflow-auto">
      <div className="flex flex-col w-full mx-auto bg-[#F5F5F5]">
        {error && (
          <Alert
            severity="error"
            sx={{
              position: 'fixed',
              width: '90%',
              margin: 'auto',
              top: 20,
              left: 0,
              right: 0,
              zIndex: 10,
            }}
          >
            <strong>{error?.message || 'Could not load driver.'}</strong>
          </Alert>
        )}

        <div className="px-10 bg-white">
          <AdminHeader
            heading={driver ? `${driver.firstName} ${driver.lastName}` : 'Driver'}
            pages={'Pages / Drivers / Driver'}
          />
        </div>

        <div className="p-10">
          <DriverPersonalComponent />
        </div>
      </div>
    </div>
  );
}

export default DriverDetailsScreen;
